/**
 * Determines if the runtime is production by checking the hostname.
 *
 * @param hostname - optional hostname; defaults to window.location.hostname
 */
const isProductionFunc = (hostname: string | undefined = document.location?.hostname): boolean => {
  return 'www.fedex.com' === hostname || 'www.fedex.com.cn' === hostname;
}

/**
 * class which exposes environment utilities
 */
export class Environment {
  static isProduction = isProductionFunc;
}
